// extracted by mini-css-extract-plugin
module.exports = {"alert":"ErrorAlert_alert__2xYnJ"};